import {
    LOADING_TIME as SourceLOADING_TIME
} from 'SourceRoute/CmsPage/CmsPage.config';

// TODO: implement LOADING_TIME
export const LOADING_TIME = SourceLOADING_TIME;
